import { api, apiEnabled } from './api.js';

const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

function applyMockFilters(items, q) {
  if (q.uf) items = items.filter((p) => p.estado === q.uf);
  if (q.cidade) items = items.filter((p) => p.cidade === q.cidade);
  if (q.tipo) items = items.filter((p) => p.tipo === q.tipo);
  if (q.banco) items = items.filter((p) => p.banco === q.banco);
  if (q.modalidade) items = items.filter((p) => p.modalidade === q.modalidade);
  if (q.precoMin) items = items.filter((p) => p.valorMinimo >= +q.precoMin);
  if (q.precoMax) items = items.filter((p) => p.valorMinimo <= +q.precoMax);
  if (q.q) {
    const t = norm(q.q);
    items = items.filter((p) => norm(p.titulo).includes(t) || norm(p.cidade).includes(t) || norm(p.endereco).includes(t));
  }
  return items;
}

export async function listProperties(query = {}) {
  if (apiEnabled) {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([k, v]) => { if (v != null && v !== '') params.set(k, v); });
    return api(`/api/properties?${params}`);
  }
  // Mock fallback — lazy import to avoid circular module initialization
  const { ALL_PROPERTIES } = await import('../data/properties.js');
  const items = applyMockFilters([...ALL_PROPERTIES], query);
  return { items, total: items.length, page: 1, pageSize: items.length };
}

export async function getProperty(id) {
  if (apiEnabled) return api(`/api/properties/${id}`);
  const property = ALL_PROPERTIES.find((p) => p.id === id);
  return property ? { property, enrichment: null } : null;
}
